export { default } from "./Promoted";
